export const CATS_CUSTOMER_CONTROLLER_ROOT_PATH = "/customer";

export const CATS_CUSTOMER_GET_ALL_PATH_PARAM_FILTER_SUBSCRIPTION = "filterSubscription";
export const CATS_CUSTOMER_GET_ALL_PATH_PARAM_SHOW_SUPPRESSED_CATS = "showSuppressedCats";
export const CATS_CUSTOMER_GET_ALL_PATH_SUFFIX = "/cats";
/** /customer/cats */
export const CATS_CUSTOMER_GET_ALL_PATH = CATS_CUSTOMER_CONTROLLER_ROOT_PATH + CATS_CUSTOMER_GET_ALL_PATH_SUFFIX;

export const CATS_CUSTOMER_UPDATE_DETAILS_PATH_SUFFIX = "/cat/update";
/** /customer/cat/update */
export const CATS_CUSTOMER_UPDATE_DETAILS_PATH =
  CATS_CUSTOMER_CONTROLLER_ROOT_PATH + CATS_CUSTOMER_UPDATE_DETAILS_PATH_SUFFIX;

export const CATS_CUSTOMER_CREATE_PATH_SUFFIX = "/cat/create";
/** /customer/cat/create */
export const CATS_CUSTOMER_CREATE_PATH = CATS_CUSTOMER_CONTROLLER_ROOT_PATH + CATS_CUSTOMER_CREATE_PATH_SUFFIX;
